import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Calendar, Phone } from 'lucide-react';
import { BOOKING_URL } from "@/constants/urls";

const BookingSection: React.FC = () => {
  return (
    <section id="booking" className="section-padding bg-gradient-to-r from-sage-100 via-sage-50 to-sage-100">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="mb-4 bg-gradient-to-r from-sage-600 to-amber-500 bg-clip-text text-transparent">Begin Your Wellness Journey</h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            Take the first step toward balanced health and well-being with Women and The Way.
          </p>
        </div>

        <Card className="highlight-box max-w-4xl mx-auto rounded-2xl shadow-lg border-4 border-amber-200/30">
          <CardContent className="p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div className="flex flex-col justify-center">
                <h3 className="text-2xl font-serif font-medium mb-4 text-sage-800">Ready to Explore?</h3>
                <p className="mb-6 text-gray-700">
                  Discover how our personalised care can support your unique wellness journey. Our practitioners are ready to guide you with compassionate, evidence-based care.
                </p>
                <div className="space-y-4">
                  <a
                    href={BOOKING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary w-full flex items-center justify-center text-white"
                  >
                    Explore Our Services <ArrowRight className="ml-2 h-4 w-4" />
                  </a>
                  <Button className="btn-outline w-full flex items-center justify-center" size="lg" asChild>
                    <a href="tel:0415537784">
                      <Phone className="mr-2 h-4 w-4" /> Get in Touch
                    </a>
                  </Button>
                </div>
              </div>
              <div className="border-t md:border-t-0 md:border-l border-sage-200 md:pl-8 pt-6 md:pt-0">
                <h3 className="text-xl font-serif font-medium mb-4 text-sage-800">What to Expect</h3>
                <ul className="space-y-3">
                  <li className="flex">
                    <span className="text-sage-600 mr-2">1.</span>
                    <span className="text-gray-700">Choose your practitioner based on your needs and their availability</span>
                  </li>
                  <li className="flex">
                    <span className="text-sage-600 mr-2">2.</span>
                    <span className="text-gray-700">Complete a brief intake form to help us understand your health concerns</span>
                  </li>
                  <li className="flex">
                    <span className="text-sage-600 mr-2">3.</span>
                    <span className="text-gray-700">Arrive 10 minutes early for your first appointment</span>
                  </li>
                  <li className="flex">
                    <span className="text-sage-600 mr-2">4.</span>
                    <span className="text-gray-700">Your practitioner will discuss your health history and create a personalised treatment plan</span>
                  </li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default BookingSection;
